/* eslint-disable @typescript-eslint/no-explicit-any */
import * as he from "he";
import React, { useEffect, useState } from "react";
import { FormattedNumber } from "react-intl";
import { Modal as ReactstrapModal, ModalBody, ModalHeader } from "reactstrap";
import { Menu, MenuItem } from "../../state/types/menuTypes";
import { useModifierSelection } from "../../hooks/useModifierSelection";
import ModifierGroupSelector from "../ModifierSelector/ModifierGroupSelector";
import Asset from "../Asset/Asset";
import MissingOptionModal from "./MissingOptionModal";

export interface IRecommendedItemModalProps {
  isOpen: boolean;
  menuItem: MenuItem;
  menu: Menu;
  onClose: () => void;
  onAddToOrder: (item: MenuItem, selectedOptions: any[]) => void;
}

const RecommendedItemModal: React.FC<IRecommendedItemModalProps> = ({
  isOpen,
  menuItem,
  menu,
  onClose,
  onAddToOrder,
}) => {
  const [missingGroupIds, setMissingGroupIds] = useState<number[]>([]);

  const {
    selectedOptions,
    setSelectedOption,
    resetToDefaults,
    validateSelection,
    deriveModifierGroups,
  } = useModifierSelection({
    menu,
    modifierGroupIds: menuItem.modifierGroupsIds,
  });

  useEffect(() => {
    if (isOpen && menuItem) {
      resetToDefaults();
      setMissingGroupIds([]);
    }
  }, [isOpen, menuItem, resetToDefaults]);

  const handleAddToOrder = () => {
    const missingIds = validateSelection();

    if (missingIds.length === 0) {
      onAddToOrder(menuItem, selectedOptions);
    } else {
      setMissingGroupIds(missingIds);
    }
  };

  const modifierGroupsDerived = deriveModifierGroups();

  const missingModifierGroups = menu.modifierGroups.filter((group) =>
    missingGroupIds.includes(group.id)
  );

  return (
    <>
      <ReactstrapModal
        isOpen={isOpen}
        toggle={onClose}
        className="recommended-item-modal"
        centered
      >
        <ModalHeader toggle={onClose}>{menuItem.name}</ModalHeader>
        <ModalBody>
          <div className="recommended-modal-content">
            <div className="recommended-modal-item-info">
              {menuItem.displayAssetId && (
                <div className="recommended-modal-image">
                  <Asset
                    thumbnailAssetId={menuItem.displayAssetId}
                    transform={"200x"}
                  />
                </div>
              )}
              {menuItem.description && (
                <div className="recommended-modal-description">
                  {he.decode(menuItem.description)}
                </div>
              )}
              <div className="recommended-modal-price">
                {menuItem.price.currencySymbol}
                <FormattedNumber
                  minimumFractionDigits={2}
                  value={menuItem.price.amount}
                />
              </div>
            </div>

            <div className="recommended-modal-options">
              <ModifierGroupSelector
                modifierGroups={modifierGroupsDerived}
                selectedOptions={selectedOptions}
                onModifierSelect={setSelectedOption}
              />
            </div>

            <div className="recommended-modal-actions">
              <button className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleAddToOrder}>
                Add to Order
              </button>
            </div>
          </div>
        </ModalBody>
      </ReactstrapModal>

      {missingModifierGroups.length > 0 && (
        <MissingOptionModal
          onDismiss={() => setMissingGroupIds([])}
          missingModifierGroups={missingModifierGroups}
        />
      )}
    </>
  );
};

export default RecommendedItemModal;
